export const codeLinesHTML = /<div data-n=".*?">.*?<\/div>/g
export const codeLineInnerHTML = /(<div data-n=".*?">)([\w\W]+?)(<\/div>)/
export const url = new RegExp(/(\b((https:\/\/)|(http:\/\/)|(ftp:\/\/)|(www\.))((.*?)[^\s\n\t\r\v]*))/).source
export const code = new RegExp(/{code}([\w\W]+?){code}/).source
export const quote = new RegExp(/\{quote type="quote-type" author=".*" dt=".*" target=".*"}[\s\S]*\{quote}/).source
export const quoteDetailed = /\{quote type="quote-type" author="(.*?)" dt="(.*?)" target="(.*?)"}(.*)\{quote}/s
export const codeHTML = /<code>.*<\/code>/s
export const quoteHTML = /<quote author="(.*?)" created="(.*?)" target="(.*?)">(.*)<\/quote>/s
export const textFormatBold = /\*{2}([^*?$\n\r]+)\*{2}/